import React from "react";
import './ChatListSeperator.css';

export default function ChatListSeperator() {
  return (
    <span class="seperator" />
  );
}
